module.exports = __webpack_public_path__ + "04_glasses_blue.3e0391d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/nakagawa/male/layer4/04_glasses_blue.png
// module id = NmqW
// module chunks = 0